<div data-testid="header-profile-image" class="__avatar-image">
  <img [src]="avatarImage$ | async" />
</div>

<ng-template #placeholder>
  <div class="bg-ui-surface size-12 animate-pulse rounded-full"></div>
</ng-template>
